import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  section: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    background: `linear-gradient(180deg, ${theme?.colors?.background2} 50%, #FFFFFF 50%)`,
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    }
    // '& h2,& h3': {
    //   fontWeight: '500',
    //   '& b,& strong': {
    //     fontWeight: '700'
    //   }
    // }
  },
  formContainer: {
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },

  // partialBackground: {
  //   top: '0',
  //   left: '0',
  //   width: '100%',
  //   height: '50%',
  //   position: 'absolute',
  //   background: theme?.colors?.white
  // },
  sectionContainer: {
    backgroundColor: theme?.colors?.white,
    boxShadow: theme?.shadows?.secondary,
    borderRadius: theme?.shape?.borderRadius?.regular,
    padding: '48px',
    position: 'relative'
  },
  title: {
    margin: '0',
    fontSize: theme.typography.fontSize.h2,
    color: theme?.colors?.lightblack,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: '71px',
    letterSpacing: '-3px',
    textAlign: 'left',
    wordBreak: 'break-word'
  },

  contentContainer: {
    width: '100%',
    display: 'flex'
    // alignItems: 'flex-start',
  },
  leftContainerForm: {
    width: '65%',
    display: 'flex',
    flexDirection: 'column'
    // justifyContent: 'space-between'
  },
  subtitle: {
    // margin: '0 0 40px 0',
    fontSize: theme.typography.fontSize.h5,
    color: theme?.colors?.lightblack,
    lineHeight: '32px',
    wordBreak: 'break-word',
    marginBottom: '32px'
  },
  addressContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '80%',
    gap: '16px'
  },
  addressRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    wordBreak: 'break-word'
  },
  addressImg: {
    padding: '4px 8px 0 0'
  },
  addressText: {
    fontSize: theme.typography.fontSize.h6,
    color: theme?.colors?.lightblack,
    lineHeight: '24px',
    fontSize: '16px'
  },
  rightContainer: {
    width: '50%',
    padding: '0 0 0 80px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  inputDiv: {
    margin: '0 0 20px 0',
    position: 'relative',
    display: 'flex'
  },
  btnContainer: {},

  '@media screen and (max-width: 767px)': {
    addressContainer: {
      gap: '0px'
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    sectionContainer: {
      // margin: '26px 16px',
      padding: '16px'
    },
    partialBackground: {
      height: '150px'
    },
    contentContainer: {
      flexDirection: 'column',
      marginTop: '8px'
    },
    leftContainerForm: {
      width: '100%'
      // padding: '0 16ox'
    },
    rightContainer: {
      width: '100%',
      padding: '0'
    },
    title: {
      // fontSize: '24px',
      lineHeight: '32px',
      letterSpacing: 'initial',
      margin: '0 0 16px 0',
      textAlign: 'center'
    },
    subtitle: {
      margin: '0 0 16px 0',
      lineHeight: '26px',
      textAlign: 'center'
    },
    inputDiv: {
      margin: '0 0 16px 0'
    },
    addressRow: {
      padding: '0px',
      margin: '0 0 16px 0'
    },
    btnContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }
}));

export default useSectionStyles;
